import { useEventEmitter } from 'ahooks';
import { createContext, useRef } from 'react';
import { createWorkflowStore } from '../store';
import { useEventFromContext } from '@/pages/CustomCenter/context/eventEmmitrContent';
type WorkflowStore = ReturnType<typeof createWorkflowStore>;
export const WorkflowContext = createContext<WorkflowStore | null>(null);

type WorkflowProviderProps = {
  children: React.ReactNode;
};
export const WorkflowContextProvider = ({
  children,
}: WorkflowProviderProps) => {
  const storeRef = useRef<WorkflowStore>();
  const eventEmitter = useEventEmitter<any>();
  const eventFromContext = useEventFromContext();

  if (!storeRef.current)
    storeRef.current = createWorkflowStore({
      eventEmitter,
      eventFromContext,
    });

  return (
    <WorkflowContext.Provider value={storeRef.current}>
      {children}
    </WorkflowContext.Provider>
  );
};
